import React, { useEffect, useState } from "react";
import { taskDetailApi } from "../../backend/client";
import {
  TaskDialog,
  TaskDialogActions,
  TaskMessage,
  TaskTextArea,
  TaskTextInput,
} from "./taskFormUi";

const today = new Date().toISOString().split("T")[0];

const BookCleanerForm = ({ projectId, onClose, onSave }) => {
  const [existingRecord, setExistingRecord] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({
    company_name: "",
    date: "",
    time: "",
    contact_number: "",
    notes: "",
  });

  useEffect(() => {
    const fetchBooking = async () => {
      if (!projectId) return;

      const { data } = await taskDetailApi.list("book-cleaner", {
        project_id: projectId,
        limit: 1,
      });

      if (data?.[0]) {
        const row = data[0];
        setExistingRecord(row);
        setFormData({
          company_name: row.company_name || "",
          date: row.date || "",
          time: row.time || "",
          contact_number: row.contact_number || "",
          notes: row.notes || "",
        });
      }
    };

    fetchBooking();
  }, [projectId]);

  const handleChange = (field, value) => {
    setFormData((previous) => ({ ...previous, [field]: value }));
  };

  const handleSave = async (event) => {
    event?.preventDefault();
    setErrorMessage("");
    setSuccessMessage("");

    if (!formData.company_name.trim()) {
      setErrorMessage("Company name is required");
      return;
    }
    if (!formData.date) {
      setErrorMessage("Booking date is required");
      return;
    }
    if (!formData.time) {
      setErrorMessage("Booking time is required");
      return;
    }

    const { error } = existingRecord?.id
      ? await taskDetailApi.update("book-cleaner", existingRecord.id, formData)
      : await taskDetailApi.create("book-cleaner", {
          project_id: projectId,
          ...formData,
        });

    if (error) {
      setErrorMessage("Failed to save cleaner booking details");
      return;
    }

    setSuccessMessage("Cleaner booking details saved successfully.");
    onSave?.();
    onClose?.();
  };

  return (
    <TaskDialog
      title="Book Cleaner Details"
      description="Cleaning provider, appointment time, and notes."
      onClose={onClose}
      className="max-w-xl"
    >
      <form onSubmit={handleSave} className="space-y-5">
        <TaskMessage>{errorMessage}</TaskMessage>
        <TaskMessage tone="success">{successMessage}</TaskMessage>

        <div className="grid gap-4 sm:grid-cols-2">
          <TaskTextInput
            id="cleaner-company"
            label="Company Name"
            value={formData.company_name}
            onChange={(event) =>
              handleChange("company_name", event.target.value)
            }
            required
            className="sm:col-span-2"
          />
          <TaskTextInput
            id="cleaner-date"
            label="Booking Date"
            type="date"
            min={today}
            value={formData.date}
            onChange={(event) => handleChange("date", event.target.value)}
            required
          />
          <TaskTextInput
            id="cleaner-time"
            label="Booking Time"
            type="time"
            value={formData.time}
            onChange={(event) => handleChange("time", event.target.value)}
            required
          />
          <TaskTextInput
            id="cleaner-contact"
            label="Contact Number"
            value={formData.contact_number}
            onChange={(event) =>
              handleChange(
                "contact_number",
                event.target.value.replace(/\D/g, ""),
              )
            }
            placeholder="+61..."
            className="sm:col-span-2"
          />
          <TaskTextArea
            id="cleaner-notes"
            label="Notes"
            value={formData.notes}
            onChange={(event) => handleChange("notes", event.target.value)}
            rows={3}
            className="sm:col-span-2"
          />
        </div>

        <TaskDialogActions onCancel={onClose} submitType="submit" />
      </form>
    </TaskDialog>
  );
};

export default BookCleanerForm;
